'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UITooltipHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UITooltipHeader(_ref) {
  var className = _ref.className,
      children = _ref.children;

  return _react2.default.createElement(
    'h2',
    { className: (0, _classNames2.default)('private-tooltip__heading', className) },
    children
  );
}

UITooltipHeader.propTypes = {
  children: _react.PropTypes.node
};

UITooltipHeader.displayName = 'UITooltipHeader';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/tooltip/UITooltipHeader.js
// module id = 464
// module chunks = 171